import { render } from "./GenericProfileSection.vue?vue&type=template&id=ce410102"
import script from "./GenericProfileSection.vue?vue&type=script&lang=js"
export * from "./GenericProfileSection.vue?vue&type=script&lang=js"
script.render = render

export default script